import { Box, Group, rem, Image, Text, SimpleGrid, useComputedColorScheme } from "@mantine/core";

export default function DeteriorationLegand(props) {
  const isDark = useComputedColorScheme("light") === "dark";
  const imgStyle = isDark ? { filter: "invert(1)" } : undefined;

  return (
    <Box {...props}>
      <SimpleGrid cols={props.cols ?? 1} spacing={props.spacing}>
        <Group gap={"sm"} wrap="nowrap">
          <Box w={rem(20)} style={{ aspectRatio: 1, ...imgStyle }}>
            <Image src={"img/gpa_images/1.png"} />
          </Box>
          <Text fw={600}>{"P < 5% Deterioration"}</Text>
        </Group>
        <Group gap={"sm"} wrap="nowrap">
          <Box w={rem(20)} style={{ aspectRatio: 1, ...imgStyle }}>
            <Image src={"img/gpa_images/2.png"} />
          </Box>
          <Text fw={600}>{"P < 5% (2 consecutive)"}</Text>
        </Group>
        <Group gap={"sm"} wrap="nowrap">
          <Box w={rem(20)} style={{ aspectRatio: 1, ...imgStyle }}>
            <Image src={"img/gpa_images/3.png"} />
          </Box>
          <Text fw={600}>{"P < 5% (3 consecutive)"}</Text>
        </Group>
        <Group gap={"sm"} wrap="nowrap">
          <Box w={rem(20)} style={{ aspectRatio: 1, ...imgStyle }}>
            <Image src={"img/gpa_images/-1.png"} />
          </Box>
          <Text fw={600}>{"Out of Range"}</Text>
        </Group>
      </SimpleGrid>
    </Box>
  );
}
